// ---------------- Hook to call the api endpoint for the tickers -------------------
// ----------------------------------------------------------------------------------
// import the services and functions
import { useState, useEffect, useCallback } from 'react';
import { getNewsData } from '../services/api';

// hook to fetch news data from the backend API
export const useNewsData = (pageSize = 20, timeframe = 'MAX') => {

  // create the state variables for data, loading and error
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // reset data immediately when timeframe changes so loading screen shows
  useEffect(() => {
    setData([]);
    setLoading(true);
    setError(null);
  }, [timeframe]);

  // fetch news data from the backend API when the comp mounts
  const fetchNews = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // call the getNewsData function from the api service with the pageSize and timeframe parameters
      const response = await getNewsData({ pageSize, timeframe });
      
      // check if the response is valid and contains articles
      if (!response?.articles) {
        throw new Error('Invalid news data received');
      }
      
      setData(response.articles);

    } catch (err) {
      console.error('Error fetching news data:', err);
      setError(err.message || 'Failed to fetch news data');
      setData([]);

    } finally {
      setLoading(false);
    }
  }, [pageSize, timeframe]);

  useEffect(() => { // call the fetchNews function when the component mounts or when pageSize or timeframe changes
    fetchNews();
  }, [fetchNews]);

  return { 
    data, 
    loading, 
    error, 
    refetch: fetchNews 
  }; // return the data, loading, error and refetch function from the hook
};
